import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import styles from './index.module.css'

const MyInfoModify = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className={styles.title}>내 정보</div>
					<ul className="list-item mt_30">
						<li>
							<span>이름</span>
							<span>김모니</span>
						</li>
						<li>
							<span>휴대폰 번호</span>
							<Link to="/setting/myInfoNumber" className="flex-align_center">
								<span>010-1234-5678</span>
								<i className="icon icon_arrow_sm right ml_5" />
							</Link>
						</li>
						<li>
							<span>이메일 주소</span>
							<Link to="/setting/myInfoEmail" className="flex-align_center">
								<span>momeey@fintech1.co.kr</span>
								<i className="icon icon_arrow_sm right ml_5" />
							</Link>
						</li>
					</ul>
				</div>
			</div>
			<div className="padding">
				<ul className={styles["link-menu"]}>
					<li>
						<Link to="">
							<p>로그아웃</p>
							<i className="icon icon_arrow_sm right" />
						</Link>
					</li>
					<li>
						<Link to="/setting/myInfoResign">
							<p>회원탈퇴</p>
							<i className="icon icon_arrow_sm right" />
						</Link>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default MyInfoModify
